// Single source of truth for site-wide constants. Anything that depends on a
// client-provided value lives here so it can be swapped without hunting through
// components. TODO(client) markers flag placeholders awaiting Kirsten.

export const site = {
  name: 'GIA Longevity US',
  fullName: 'Global Initiative on Ageing and Longevity, U.S. Chapter',
  tagline: 'A world built for longevity', // from Brand Book May 2025 (Vision)
  vision: 'A World Built for Longevity',
  mission:
    'Our mission is to design a new society that empowers everyone to thrive throughout their longer lives.',
  url: 'https://gialongevity.us',
  summitUrl: 'https://www.lifespan-summit.com/',
  uberAnnouncementUrl:
    'https://gialongevity.org/gia-longevity-partners-with-uber-to-advance-mobility-solutions-for-aging-populations/',
  // Official general contact (confirmed by client 22 Sep 2026).
  contactEmail: 'info@gialongevity.us',
  contactPhone: '+1-703-829-6366',
  globalUrl: 'https://gialongevity.org',
  // Until the donation platform is live, every Donate CTA scrolls to the
  // Donate section, which shows the mailing address for checks. Swap this for
  // the platform URL once it's ready.
  donateUrl: '/#donate',
  donationMailingAddress: [
    'GIA Longevity U.S.',
    '8317 Rising Ridge Way',
    'Bethesda, MD 20817',
  ],
  ein: '82-2995334',
  social: {
    linkedin: 'https://www.linkedin.com/company/gia-longevity',
    x: 'https://x.com/gialongevity',
    instagram: 'https://www.instagram.com/gialongevity/',
  },
} as const

export type Site = typeof site
